import { VERIFICATION_STATUSES } from '../../constants/verificationStatuses'

export default function StatusPill({ status }) {
  const colorClass = VERIFICATION_STATUSES[status]?.color || 'bg-neutral-200-100 text-gray-800'
  const label = VERIFICATION_STATUSES[status]?.label || status

  return (
    <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${colorClass}`}>
      {label}
    </span>
  )
}
